import React from 'react';
import PropTypes from 'prop-types';

const CancelButton = ({distributionInProgress, onCloseModal}) => (
    <button
        className="btn btn-danger distribution-modal-button"
        disabled={distributionInProgress}
        onClick={onCloseModal}
    >
        Cancel
    </button>
);

CancelButton.propTypes = {
    distributionInProgress: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired
};

export default CancelButton;



// WEBPACK FOOTER //
// ./approval_queues/components/content_review/list_view/content_row/add_distribution_modal/cancel_button.js